let slider = document.querySelector('.js-product-slider');
let productCards = slider.querySelectorAll('.gallery-cell');
let card = productCards[0];

// Change card color text
function setColorText(button) {
  let color = button.getAttribute('data-swatch-color');
  let colorElement = button
    .closest('.thumbnail')
    .querySelector('.variant-color');
  colorElement.innerText = color;
}

function setSelectedState(button) {
  let productSwatches = button.parentElement.querySelectorAll('button');
  productSwatches.forEach(b => {
    if (b.hasAttribute('selected')) b.removeAttribute('selected');
  });

  button.setAttribute('selected', '');
}

// Change all variant links by clicking on swatch
function handleVariantLinkChange(button) {
  try {
    const variantUrl = button.dataset.product_url;
    const productCard = button.closest('.thumbnail');
    const cardLinks = productCard.querySelectorAll('a');
    cardLinks.forEach(l => l.setAttribute('href', variantUrl));
  } catch (err) {
    console.error(err);
    // ? [REVISIT] Combine with image swap and simply copy/replace element from other variant images
  }
}

// Change variant image by clicking on swatch
function handleShowVariantImages(card, variantId, isPrimary) {
  try {
    let variantImageContainers = card.querySelectorAll('.image__container');
    for (let imageContainer of variantImageContainers) {
      if (!isPrimary) {
        if (imageContainer.classList.contains('show')) {
          imageContainer.classList.value = 'image__container hide';
        }
        if (imageContainer.dataset.product_id == variantId) {
          imageContainer.classList.value = 'image__container show';
        }
      } else {
        /* primary/first swatch chosen */
        imageContainer.classList.value = 'image__container hide';
        variantImageContainers[0].classList.value = 'image__container show';
      }
    }
  } catch (err) {
    console.error(err);
  }
}

for (let card of productCards) {
  let primarySwatch = card.querySelector('[data-primary="true"]');
  let imageElement = card.querySelector('.image__container');
  /* add Show to first image element */
  imageElement.classList.add('show');
  imageElement.setAttribute('primary', '');
  imageElement.setAttribute(
    'data-product_id',
    primarySwatch.dataset.product_id
  );
}
for (let card of productCards) {
  let imageElement = card.querySelector('.image__container');

  /* clone image element with alt images */
  const swatches = card.querySelectorAll('button');
  swatches.forEach(s => {
    let isPrimary = s.dataset.primary;
    if (isPrimary) {
      s.setAttribute('selected', '');
      s.setAttribute('data-button-primary', '');
    } else {
      let clonedNode = imageElement.cloneNode(true);
      clonedNode.classList.contains('show')
        ? clonedNode.classList.remove('show')
        : '';
      clonedNode.classList.add('hide');
      clonedNode.setAttribute('data-product_id', s.dataset.product_id);
      let nodeImages = clonedNode.querySelectorAll('img');
      nodeImages[0].setAttribute('src', s.dataset.firstImgUrl);
      nodeImages[0].setAttribute('data-src', s.dataset.firstImgUrl);
      nodeImages[0].setAttribute('srcset', s.dataset.firstImgSrcset);
      nodeImages[0].setAttribute('data-srcset', s.dataset.firstImgSrcset);
      nodeImages[1].setAttribute('src', s.dataset.secondImgUrl);
      nodeImages[1].setAttribute('data-src', s.dataset.secondImgUrl);
      nodeImages[1].setAttribute('srcset', s.dataset.secondImgSrcset);
      nodeImages[1].setAttribute('data-srcset', s.dataset.secondImgSrcset);

      imageElement.after(clonedNode);
    }
  });

  swatches.forEach(s => {
    s.addEventListener('click', e => {
      let button = e.target;
      if (!button.classList.contains('swatch')) button = e.target.parentElement;

      handleVariantLinkChange(button);
      handleShowVariantImages(
        button.closest('.gallery-cell'),
        button.dataset.product_id,
        button.hasAttribute('data-button-primary')
      );
      setSelectedState(button);
      setColorText(button);
    });
  });
}
